import { useState } from 'react'
import ServiceScrollSection from './ServiceScrollSection'
import TechDesign from './TechDesign'
import ContactFormNew from './ContactFormNew'
const wordpress = true
const imagepath = wordpress ? '/wp-content/reactpress/apps/idesign/' : '/'

const Home = () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <div className='site-wrap'>
        {/* ======= Header =======*/}
        <header
          className='fbs__net-navbar navbar navbar-expand-lg dark '
          aria-label='idesign navbar'
        >
          <div className='container d-flex align-items-center justify-content-between'>
            {/* Start Logo*/}

            {/*<span className='brand-text logotext'>
                <span className='brand-line1'>
                  <span className='logo-design'>iDESIGN</span>
                </span>
                {/* <span className='brand-line2'>Technologies Pvt Ltd</span> */}
            {/*</span> */}
            <a href='#home'>
              <img
                className='logo light img-fluid'
                src={`${imagepath}assets/images/idesign.jpg`}
                alt='idesign light'
                style={{ height: '40px' }}
              />
            </a>
            {/* End Logo*/}
            {/* Start offcanvas*/}
            <div
              className='offcanvas offcanvas-start align-items-end  w-md-75  pe-3'
              // style={{ backgroundColor: 'unset!important' }}
              id='fbs__net-navbars'
              tabIndex={-1}
              aria-labelledby='fbs__net-navbarsLabel'
            >
              <div className='offcanvas-body align-items-lg-center'>
                <ul className='navbar-nav nav me-auto ps-lg-5 mb-2 mb-lg-0'>
                  <li className='nav-item'>
                    <a
                      className='nav-link scroll-link text-sm font-medium text-muted-foreground hover:text-foreground transition-colors'
                      aria-current='page'
                      href='#home'
                    >
                      Home
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link scroll-link text-sm font-medium text-muted-foreground hover:text-foreground transition-colors'
                      href='#about'
                    >
                      About us
                    </a>
                  </li>

                  <li className='nav-item'>
                    <a
                      className='nav-link scroll-link text-sm font-medium text-muted-foreground hover:text-foreground transition-colors'
                      href='#services'
                    >
                      Services
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link scroll-link text-sm font-medium text-muted-foreground hover:text-foreground transition-colors'
                      href='#products'
                    >
                      Products
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link scroll-link text-sm font-medium text-muted-foreground hover:text-foreground transition-colors'
                      href='#how-it-works'
                    >
                      How It Works
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            {/* End offcanvas*/}
            <div className='ms-auto w-auto'>
              <div className='header-social d-flex align-items-center gap-2'>
                <button
                  className='btn btn-primary text-sm px-4 py-2 white-color'
                  onClick={() => setShowModal(true)}
                >
                  Contact
                </button>
                {/* <button
                  id='themeToggleBtn'
                  type='button'
                  aria-label='Toggle theme'
                  style={{
                    boxShadow: 'none',
                    background: 'none',
                    border: 'none',
                    padding: '0px!important',
                  }}
                >
                  <i className='bi bi-moon' id='themeIcon'></i>
                </button>*/}
                <button
                  className='fbs__net-navbar-toggler justify-content-center align-items-center ms-auto'
                  data-bs-toggle='offcanvas'
                  data-bs-target='#fbs__net-navbars'
                  aria-controls='fbs__net-navbars'
                  aria-label='Toggle navigation'
                  aria-expanded='false'
                >
                  <svg
                    className='fbs__net-icon-menu'
                    xmlns='http://www.w3.org/2000/svg'
                    width={24}
                    height={24}
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth={2}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <line x1={21} x2={3} y1={6} y2={6} />
                    <line x1={15} x2={3} y1={12} y2={12} />
                    <line x1={17} x2={3} y1={18} y2={18} />
                  </svg>
                  <svg
                    className='fbs__net-icon-close'
                    xmlns='http://www.w3.org/2000/svg'
                    width={24}
                    height={24}
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='currentColor'
                    strokeWidth={2}
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  >
                    <path d='M18 6 6 18' />
                    <path d='m6 6 12 12' />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </header>
        {/* End Header*/}
        {/* ======= Main =======*/}
        <main>
          {/* ======= Hero =======*/}
          <section
            id='home'
            className='relative overflow-hidden py-12 sm:py-16 lg:py-24 bg-gradient-to-br from-background via-primary/5 to-background'
            style={{ paddingTop: '110px' }}
          >
            <div class='absolute inset-0 bg-grid-pattern opacity-[0.02]'></div>
            <div class='absolute top-0 right-0 w-96 h-96 bg-primary/10 rounded-full blur-3xl'></div>
            <div class='absolute bottom-0 left-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl'></div>
            {/* sm:px-6 lg:px-8 px-4 */}
            <div className='container mx-auto  relative z-10'>
              <div className='grid lg:grid-cols-2 gap-8 lg:gap-12 items-center'>
                <div className='space-y-6'>
                  <div className='flex flex-wrap items-center gap-4'>
                    <div className='inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 border border-primary/20'>
                      <svg
                        className='h-4 w-4 text-primary'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth='2'
                          d='M13 7h8m0 0v8m0-8l-8 8-4-4-6 6'
                        />
                      </svg>
                      <span className='text-xs font-medium text-primary'>
                        Dynamic. Interactive. Unforgettable.
                      </span>
                    </div>
                  </div>

                  <h1
                    className='text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tight leading-tight'
                    data-aos='fade-up'
                    data-aos-delay={100}
                  >
                    Building <span className='text-primary'>YOUR</span>{' '}
                    Innovative Digital Experiences
                  </h1>

                  <p
                    className='text-base sm:text-lg lg:text-xl text-muted-foreground leading-relaxed'
                    data-aos='fade-up'
                    data-aos-delay={200}
                  >
                    We don't just build software—we partner with you to
                    understand your unique vision and challenges. Every solution
                    we create is thoughtfully tailored to your specific needs,
                    ensuring your digital presence truly reflects your business
                    and resonates with your audience.
                  </p>

                  <div className='grid grid-cols-2 gap-3 py-2'>
                    <div className='flex items-center gap-2'>
                      <div className='flex h-8 w-8 items-center justify-center rounded-lg bg-primary/10'>
                        <svg
                          className='h-4 w-4 text-primary'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z'
                          />
                        </svg>
                      </div>
                      <span className='text-sm font-medium'>
                        Your Dedicated Team
                      </span>
                    </div>
                    <div className='flex items-center gap-2'>
                      <div className='flex h-8 w-8 items-center justify-center rounded-lg bg-primary/10'>
                        <svg
                          className='h-4 w-4 text-primary'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M13 10V3L4 14h7v7l9-11h-7z'
                          />
                        </svg>
                      </div>
                      <span className='text-sm font-medium'>
                        Tailored Solutions
                      </span>
                    </div>
                    <div className='flex items-center gap-2'>
                      <div className='flex h-8 w-8 items-center justify-center rounded-lg bg-primary/10'>
                        <svg
                          className='h-4 w-4 text-primary'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
                          />
                        </svg>
                      </div>
                      <span className='text-sm font-medium'>
                        Your Success First
                      </span>
                    </div>
                    <div className='flex items-center gap-2'>
                      <div className='flex h-8 w-8 items-center justify-center rounded-lg bg-primary/10'>
                        <svg
                          className='h-4 w-4 text-primary'
                          fill='none'
                          stroke='currentColor'
                          viewBox='0 0 24 24'
                        >
                          <path
                            strokeLinecap='round'
                            strokeLinejoin='round'
                            strokeWidth='2'
                            d='M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4'
                          />
                        </svg>
                      </div>
                      <span className='text-sm font-medium'>Built for You</span>
                    </div>
                  </div>

                  <div className='flex flex-col sm:flex-row gap-3 pt-2'>
                    <button
                      className='btn btn-primary text-base'
                      onClick={() => setShowModal(true)}
                    >
                      Let's Build Together
                      <svg
                        className='ml-2 h-4 w-4'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth='2'
                          d='M14 5l7 7m0 0l-7 7m7-7H3'
                        />
                      </svg>
                    </button>
                    <a href='#products' className='btn btn-outline text-base'>
                      See Our Work
                    </a>
                  </div>

                  <div className='flex items-center gap-6 pt-2'>
                    <div className='flex -space-x-2'>
                      <div className='h-8 w-8 trust-bg-color rounded-full bg-gradient-to-br from-primary/80 to-primary border-2 border-background'></div>
                      <div className='h-8 w-8 trust-bg-color rounded-full bg-gradient-to-br from-primary/80 to-primary border-2 border-background'></div>
                      <div className='h-8 w-8 trust-bg-color rounded-full bg-gradient-to-br from-primary/80 to-primary border-2 border-background'></div>
                      <div className='h-8 w-8 trust-bg-color rounded-full bg-gradient-to-br from-primary/80 to-primary border-2 border-background'></div>
                    </div>
                    <div className='text-sm'>
                      <div className='font-semibold'>50+ Trusted Partners</div>
                      <div className='text-muted-foreground'>
                        Growing together since 2015
                      </div>
                    </div>
                  </div>
                </div>

                <div className='relative lg:pl-8'>
                  {/* <div className='absolute -top-4 -left-4 z-10 hidden lg:block'>
                    <div className='card p-3 shadow-xl bg-background/95 backdrop-blur'>
                      <div className='flex items-center gap-2'>
                        <div className='h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center'>
                          <svg
                            className='h-5 w-5 text-primary'
                            fill='none'
                            stroke='currentColor'
                            viewBox='0 0 24 24'
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              strokeWidth='2'
                              d='M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                            />
                          </svg>
                        </div>
                        <div>
                          <div className='text-xs text-muted-foreground'>
                            Web Apps
                          </div>
                          <div className='text-sm font-semibold'>
                            50+ Delivered
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  {/* <div className='absolute -bottom-4 -right-1 z-10 hidden lg:block'>
                    <div className='card p-3 shadow-xl bg-background/95 backdrop-blur'>
                      <div className='flex items-center gap-2'>
                        <div className='h-10 w-10 rounded-lg bg-primary/10 flex items-center justify-center'>
                          <svg
                            className='h-5 w-5 text-primary'
                            fill='none'
                            stroke='currentColor'
                            viewBox='0 0 24 24'
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              strokeWidth='2'
                              d='M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z'
                            />
                          </svg>
                        </div>
                        <div>
                          <div className='text-xs text-muted-foreground'>
                            Mobile Apps
                          </div>
                          <div className='text-sm font-semibold'>
                            40+ Launched
                          </div>
                        </div>
                      </div>
                    </div>
                  </div> */}

                  <div className='relative aspect-square flex items-center justify-center'>
                    <div className='absolute inset-0 bg-gradient-to-br from-primary/20 to-primary/5 rounded-3xl blur-2xl'></div>
                    <img
                      src={`${imagepath}assets/images/hero-img-removebg-preview (1).png`}
                      alt='Digital Innovation'
                      className='relative w-full h-full object-contain drop-shadow-2xl'
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* <section className='hero__v6 section' id='home'>
            <div className='container'>
              <div className='row align-items-center justify-content-between'>
                <div className='col-lg-6 align-items-center mb-4 mb-lg-0'>
                  <div className='row'>
                    <div className='col-lg-12'>
                      <span
                        className='hero-subtitle text-uppercase'
                        data-aos='fade-up'
                        data-aos-delay={0}
                      >
                        Dynamic. Interactive. Unforgettable.
                      </span>
                      {/* <h1
                        className='hero-title mb-3'
                        data-aos='fade-up'
                        data-aos-delay={100}
                      >
                        Building Innovative Digital Experiences
                      </h1> */}
          {/* <h1 className="text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-bold tracking-tight leading-tight">
              Building <span className="text-primary">YOUR</span> Innovative Digital Experiences
            </h1>  */}
          {/* <p
                        className='description mb-4 mb-lg-5'
                        data-aos='fade-up'
                        data-aos-delay={200}
                      >
                        Driving Success Through Web and Mobile Solutions.
                        Empowering Your Business—One Product at a Time.
                      </p> */}
          {/* <p className="text-base sm:text-lg lg:text-xl text-muted-foreground leading-relaxed">
                        We don't just build softwareâ€”we partner with you to understand your unique vision and challenges. Every
                        solution we create is thoughtfully tailored to your specific needs, ensuring your digital presence truly
                        reflects your business and resonates with your audience.
                      </p>
                      <div
                        className='cta d-flex gap-2 mb-4 mb-lg-5'
                        data-aos='fade-up'
                        data-aos-delay={300}
                      > */}
          {/* <button className='btn' type='button'>
                          Get Started Now
                        </button> */}
          {/* </div>
                    </div>
                  </div>
                </div>
                <div className='col-lg-12'>
                  <div className='hero-img '>
                    <img
                      className='img-main img-fluid rounded-4'
                      src='/assets/images/hero-img.png'
                      alt='Hero'
                      data-aos='zoom-out'
                      data-aos-delay={500}
                    />
                  </div>
                </div>
              </div>
            </div>  
            {/* End Hero 
          </section> */}
          {/* End Hero*/}

          <div className='section clients__v2   p-0'>
            <div className='container'>
              <div className='row mb-5'>
                <div className='col-md-8 mx-auto text-center'>
                  <span
                    className='subtitle text-uppercase mb-3'
                    data-aos='fade-up'
                    data-aos-delay={0}
                  >
                    Our customers
                  </span>
                  <p
                    data-aos='fade-up'
                    data-aos-delay={100}
                    className='description text-muted-foreground'
                  >
                    Our customers are value-driven individuals and businesses
                    seeking reliable solutions and exceptional service.
                  </p>
                </div>
              </div>
              <div className='row g-4'>
                <main className='wrapper'>
                  <div className='marquee platforms-item'>
                    <img
                      className='client-logo'
                      src={`${imagepath}assets/images/client/racar.jpg`}
                      alt='racar'
                    />
                    <img
                      className='client-logo'
                      src={`${imagepath}assets/images/client/delco.jpg`}
                      alt='delco'
                    />
                    <img
                      className='client-logo'
                      src={`${imagepath}assets/images/client/delphi.jpg`}
                      alt='delphi'
                    />
                    <img
                      className='client-logo'
                      src={`${imagepath}assets/images/client/quest.jpg`}
                      alt='quest'
                    />
                    <img
                      className='client-logo'
                      src={`${imagepath}assets/images/client/lt.jpg`}
                      alt='lt'
                    />
                    <img
                      className='client-logo'
                      src={`${imagepath}assets/images/client/triad.jpg`}
                      alt='triad'
                    />
                    <img
                      className='client-logo'
                      src={`${imagepath}assets/images/client/au-frg.jpg`}
                      alt='au-frg'
                    />
                    <img
                      className='client-logo'
                      src={`${imagepath}assets/images/client/gamesha.jpg`}
                      alt='gamesha'
                    />
                    <img
                      className='client-logo'
                      src={`${imagepath}assets/images/client/shs.jpg`}
                      alt='shs'
                    />
                  </div>
                </main>
              </div>
            </div>
          </div>
          {/* ======= About =======*/}

          {/* <section id="about" className="py-20 sm:py-32" style={{ paddingBottom: '0px!important' }}>

            <div className="container mx-auto px-4 sm:px-6 lg:px-8 about__v4">

              <div className="grid lg:grid-cols-2 gap-12 items-center">

                <div className="relative">

                  <img
                    className='img-fluid rounded-4'
                    src='/assets/images/modern-tech-team-collaborating-in-office.jpg'
                    alt='idesign about'
                    data-aos='fade-up'
                    data-aos-delay={0}
                  />
                </div>
                <div className="space-y-6">
                  <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold">About iDesign Technologies</h2>
                  <p className="text-lg text-muted-foreground leading-relaxed" data-aos='fade-up'
                    data-aos-delay={200}>
                    We are a team of passionate developers, designers, and strategists dedicated to creating exceptional
                    digital experiences. With years of experience and a commitment to excellence, we help businesses
                    transform their ideas into reality.
                  </p>
                  <p className="text-lg text-muted-foreground leading-relaxed">
                    Our mission is to empower businesses with innovative technology solutions that drive growth, enhance
                    efficiency, and create lasting value for their customers.
                  </p>
                  <div className="space-y-3">
                    <div className="flex items-center gap-3">
                      <svg className="h-5 w-5 text-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span className="text-muted-foreground">Expert team of developers and designers</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <svg className="h-5 w-5 text-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span className="text-muted-foreground">Proven track record of successful projects</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <svg className="h-5 w-5 text-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span className="text-muted-foreground">Agile development methodology</span>
                    </div>
                    <div className="flex items-center gap-3">
                      <svg className="h-5 w-5 text-primary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span className="text-muted-foreground">Transparent communication and collaboration</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section> */}
          <section className='about__v4 section' id='about'>
            <div className='container'>
              <div className='row'>
                <div className='col-md-6 order-md-2'>
                  <div className='row justify-content-end'>
                    <div className='col-md-11 mb-4 mb-md-0'>
                      <span
                        className='subtitle text-uppercase mb-3'
                        data-aos='fade-up'
                        data-aos-delay={0}
                      >
                        About us
                      </span>

                      <div
                        data-aos='fade-up'
                        data-aos-delay={200}
                        className='description'
                      >
                        <p className='text-lg text-muted-foreground leading-relaxed'>
                          We are a team of passionate developers, designers, and
                          strategists dedicated to creating exceptional digital
                          experiences. With years of experience and a commitment
                          to excellence, we help businesses transform their
                          ideas into reality.
                        </p>
                        <p className='text-lg text-muted-foreground leading-relaxed mt-4'>
                          Our mission is to empower businesses with innovative
                          technology solutions that drive growth, enhance
                          efficiency, and create lasting value for their
                          customers.
                        </p>
                      </div>
                      <div className='space-y-3 mt-4'>
                        <div className='flex items-center gap-3'>
                          <svg
                            className='h-5 w-5 text-primary flex-shrink-0'
                            fill='none'
                            stroke='currentColor'
                            viewBox='0 0 24 24'
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              strokeWidth='2'
                              d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
                            />
                          </svg>
                          <span className='text-muted-foreground'>
                            Expert team of developers and designers
                          </span>
                        </div>
                        <div className='flex items-center gap-3'>
                          <svg
                            className='h-5 w-5 text-primary flex-shrink-0'
                            fill='none'
                            stroke='currentColor'
                            viewBox='0 0 24 24'
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              strokeWidth='2'
                              d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
                            />
                          </svg>
                          <span className='text-muted-foreground'>
                            Proven track record of successful projects
                          </span>
                        </div>
                        <div className='flex items-center gap-3'>
                          <svg
                            className='h-5 w-5 text-primary flex-shrink-0'
                            fill='none'
                            stroke='currentColor'
                            viewBox='0 0 24 24'
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              strokeWidth='2'
                              d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
                            />
                          </svg>
                          <span className='text-muted-foreground'>
                            Agile development methodology
                          </span>
                        </div>
                        <div className='flex items-center gap-3'>
                          <svg
                            className='h-5 w-5 text-primary flex-shrink-0'
                            fill='none'
                            stroke='currentColor'
                            viewBox='0 0 24 24'
                          >
                            <path
                              strokeLinecap='round'
                              strokeLinejoin='round'
                              strokeWidth='2'
                              d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
                            />
                          </svg>
                          <span className='text-muted-foreground'>
                            Transparent communication and collaboration
                          </span>
                        </div>
                      </div>
                      <div
                        className='mission-statement p-4 rounded-4 d-flex gap-4 mt-4'
                        data-aos='fade-up'
                        data-aos-delay={100}
                      >
                        <div className='mission-icon text-center rounded-circle'>
                          <i className='bi bi-lightbulb fs-4' />
                        </div>
                        <div>
                          <h3 className='fs-5 text-uppercase fw-bold'>
                            Mission Statement
                          </h3>
                          <p className='fs-6 mb-0 missionst'>
                            At iDesign, excellence, reliability, and customer
                            satisfaction drive everything we do. We measure
                            success by your success, delivering exceptional
                            digital products through cutting-edge engineering
                            practices and genuine collaboration.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div className='img-wrap position-relative'>
                    <img
                      className='img-fluid rounded-4 missionimg'
                      src={`${imagepath}assets/images/office-collaborating.png`}
                      alt='idesign about'
                      data-aos='fade-up'
                      data-aos-delay={0}
                      style={{
                        width: '100%',
                        height: 'auto',
                        display: 'block',
                      }} // Fallback
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* End About*/}
          {/* ======= Services =======*/}
          <section className='section services__v3 ' id='services'>
            <div className='container'>
              <div className='row mb-5'>
                <div className='col-md-8 mx-auto text-center'>
                  <span
                    className='subtitle text-uppercase mb-3'
                    data-aos='fade-up'
                    data-aos-delay={0}
                  >
                    Our Services
                  </span>
                  {/* <h2 className='mb-3' data-aos='fade-up' data-aos-delay={100}>
                    Empowering Digital Innovation Through Cutting-Edge Services
                  </h2> */}
                  <p
                    data-aos='fade-up'
                    data-aos-delay={200}
                    className='description text-muted-foreground'
                  >
                    Empowering digital innovation through cutting-edge services
                  </p>
                </div>
              </div>
              <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-8'>
                <div className='card'>
                  <div className='space-y-4'>
                    <div className='flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10'>
                      <svg
                        className='h-6 w-6 text-primary'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth='2'
                          d='M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                        />
                      </svg>
                    </div>
                    <h3 className='text-xl font-semibold'>Web Development</h3>
                    <p className='text-muted-foreground leading-relaxed'>
                      Custom websites and web applications built with modern
                      technologies for optimal performance and user experience.
                    </p>
                  </div>
                </div>

                <div className='card'>
                  <div className='space-y-4'>
                    <div className='flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10'>
                      <svg
                        className='h-6 w-6 text-primary'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth='2'
                          d='M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z'
                        />
                      </svg>
                    </div>
                    <h3 className='text-xl font-semibold'>
                      Mobile Development
                    </h3>
                    <p className='text-muted-foreground leading-relaxed'>
                      Native and cross-platform mobile apps that engage users
                      and drive business growth on iOS and Android.
                    </p>
                  </div>
                </div>

                <div className='card'>
                  <div className='space-y-4'>
                    <div className='flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10'>
                      <svg
                        className='h-6 w-6 text-primary'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth='2'
                          d='M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4'
                        />
                      </svg>
                    </div>
                    <h3 className='text-xl font-semibold'>Custom Software</h3>
                    <p className='text-muted-foreground leading-relaxed'>
                      Tailored software solutions designed to solve your unique
                      business challenges and streamline operations.
                    </p>
                  </div>
                </div>

                <div className='card'>
                  <div className='space-y-4'>
                    <div className='flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10'>
                      <svg
                        className='h-6 w-6 text-primary'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth='2'
                          d='M13 10V3L4 14h7v7l9-11h-7z'
                        />
                      </svg>
                    </div>
                    <h3 className='text-xl font-semibold'>UI/UX Design</h3>
                    <p className='text-muted-foreground leading-relaxed'>
                      Beautiful, intuitive interfaces that delight users and
                      enhance engagement with your digital products.
                    </p>
                  </div>
                </div>

                <div className='card'>
                  <div className='space-y-4'>
                    <div className='flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10'>
                      <svg
                        className='h-6 w-6 text-primary'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth='2'
                          d='M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z'
                        />
                      </svg>
                    </div>
                    <h3 className='text-xl font-semibold'>Consulting</h3>
                    <p className='text-muted-foreground leading-relaxed'>
                      Expert guidance on technology strategy, architecture, and
                      best practices to accelerate your digital transformation.
                    </p>
                  </div>
                </div>

                <div className='card'>
                  <div className='space-y-4'>
                    <div className='flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10'>
                      <svg
                        className='h-6 w-6 text-primary'
                        fill='none'
                        stroke='currentColor'
                        viewBox='0 0 24 24'
                      >
                        <path
                          strokeLinecap='round'
                          strokeLinejoin='round'
                          strokeWidth='2'
                          d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
                        />
                      </svg>
                    </div>
                    <h3 className='text-xl font-semibold'>Quality Assurance</h3>
                    <p className='text-muted-foreground leading-relaxed'>
                      Comprehensive testing and QA services to ensure your
                      applications are reliable, secure, and bug-free.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* Services*/}

          {/* ======= Products ======= */}
          <div
            className='section services__v7'
            id='products'
            style={{ paddingBottom: '20px' }}
          >
            <div className='container'>
              <div className='row mb-5'>
                <div className='col-md-6 text-center mx-auto'>
                  <span
                    className='subtitle text-uppercase mb-3 '
                    data-aos='fade-up'
                    data-aos-delay={0}
                  >
                    Some of our projects
                  </span>
                  <p
                    data-aos='fade-up'
                    data-aos-delay={100}
                    className='description text-muted-foreground'
                  >
                    Our products are high-quality, user-focused solutions
                    designed to meet real-world needs with simplicity and
                    reliability.
                  </p>
                </div>
              </div>
              <div className='row g-3 mb-5'>
                <ServiceScrollSection />
              </div>
            </div>
          </div>
          {/* End products */}
          {/* ======= How it works =======*/}
          <section className='section howitworks__v1' id='how-it-works'>
            <div className='container'>
              <div className='row mb-5'>
                <div className='col-md-6 text-center mx-auto'>
                  <span
                    className='subtitle text-uppercase mb-3'
                    data-aos='fade-up'
                    data-aos-delay={0}
                  >
                    How it works
                  </span>
                  <p
                    data-aos='fade-up'
                    data-aos-delay={100}
                    className='description text-muted-foreground'
                  >
                    We follow a streamlined, collaborative process to design and
                    develop user-focused digital experiences
                  </p>
                </div>
              </div>
              <div className='row g-md-5'>
                <div className='col-md-6 col-lg-3'>
                  <div
                    className='step-card text-center h-100 d-flex flex-column justify-content-start position-relative'
                    data-aos='fade-up'
                    data-aos-delay={0}
                  >
                    <div data-aos='fade-right' data-aos-delay={500}>
                      <img
                        className='arch-line'
                        src={`${imagepath}assets/images/arch-line.svg`}
                        alt='arch-line'
                      />
                    </div>
                    <span className='step-number rounded-circle text-center fw-bold mb-5 mx-auto step-number1'>
                      1
                    </span>
                    <div>
                      <h3 className='fs-5 mb-4 font-semibold'>
                        Contact & analyze
                      </h3>
                      <p className='description text-muted-foreground'>
                        Choose the most reliable architecture and suitable
                        programming languages.
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className='col-md-6 col-lg-3'
                  data-aos='fade-up'
                  data-aos-delay={600}
                >
                  <div className='step-card reverse text-center h-100 d-flex flex-column justify-content-start position-relative'>
                    <div data-aos='fade-right' data-aos-delay={1100}>
                      <img
                        className='arch-line reverse'
                        src={`${imagepath}assets/images/arch-line-reverse.svg`}
                        alt='arch-line-reverse'
                      />
                    </div>
                    <span className='step-number rounded-circle text-center fw-bold mb-5 mx-auto step-number2'>
                      2
                    </span>
                    <h3 className='fs-5 mb-4 font-semibold'>Proposal</h3>
                    <p className='description text-muted-foreground'>
                      Prepare the roadmap of the project and describe the steps
                      of it.
                    </p>
                  </div>
                </div>
                <div
                  className='col-md-6 col-lg-3'
                  data-aos='fade-up'
                  data-aos-delay={1200}
                >
                  <div className='step-card text-center h-100 d-flex flex-column justify-content-start position-relative'>
                    <div data-aos='fade-right' data-aos-delay={1700}>
                      <img
                        className='arch-line'
                        src={`${imagepath}assets/images/arch-line.svg`}
                        alt='arch-line'
                      />
                    </div>
                    <span className='step-number rounded-circle text-center fw-bold mb-5 mx-auto step-number3'>
                      3
                    </span>
                    <h3 className='fs-5 mb-4 font-semibold'>Start Project</h3>
                    <p className='description text-muted-foreground'>
                      We work on Agile, two-week sprints, fully transparent
                      process.
                    </p>
                  </div>
                </div>
                <div
                  className='col-md-6 col-lg-3'
                  data-aos='fade-up'
                  data-aos-delay={1800}
                >
                  <div className='step-card last text-center h-100 d-flex flex-column justify-content-start position-relative'>
                    <span className='step-number rounded-circle text-center fw-bold mb-5 mx-auto'>
                      4
                    </span>
                    <div>
                      <h3 className='fs-5 mb-4 font-semibold'>Deploy</h3>
                      <p className='description text-muted-foreground'>
                        Deploy the project.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          {/* End How it works */}

          {/* ======= Technology ======= */}
          <div
            className='section services__v7'
            id='services'
            style={{ paddingBottom: '20px' }}
          >
            <div className='container'>
              <div className='row '>
                <div className='col-md-6 text-center mx-auto'>
                  <span
                    className='subtitle text-uppercase'
                    data-aos='fade-up'
                    data-aos-delay={0}
                  >
                    Technology
                  </span>
                  <p
                    data-aos='fade-up'
                    data-aos-delay={100}
                    className='description text-muted-foreground'
                  >
                    We leverage a modern technology stack to build robust,
                    scalable, and high-performance solutions tailored to your
                    goals.
                  </p>
                </div>
              </div>
              <div className='row g-3 mb-5'>
                <TechDesign />
              </div>
            </div>
          </div>
          {/* End Technology */}

          {/* ======= Contact =======*/}
          {/* <section className='section contact__v2' id='contact'>
            <div className='container'>
              <div className='row mb-5'>
                <div className='col-md-6 col-lg-7 mx-auto text-center'>
                  <span
                    className='subtitle text-uppercase mb-3'
                    data-aos='fade-up'
                    data-aos-delay={0}
                  >
                    Contact Us
                  </span>
                  
                  <p
                    data-aos='fade-up'
                    data-aos-delay={100}
                    className='description text-muted-foreground'
                  >
                    Utilize our tools to develop your concepts and bring your
                    vision to life. Once complete, effortlessly share your
                    creations.
                  </p>
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6'>
                  <div className='d-flex gap-5 flex-column'>
                    <div
                      className='d-flex align-items-start gap-3'
                      data-aos='fade-up'
                      data-aos-delay={0}
                    >
                      <div className='icon d-block'>
                        <i className='bi bi-telephone' />
                      </div>
                      <span>
                        <span className='d-block'>Phone</span>
                        <strong>+91-422-4541284</strong>
                        
                      </span>
                    </div>
                    <div
                      className='d-flex align-items-start gap-3'
                      data-aos='fade-up'
                      data-aos-delay={100}
                    >
                      <div className='icon d-block'>
                        <i className='bi bi-send' />
                      </div>
                      <span>
                        <span className='d-block'>Email</span>
                        <strong>anand@i-design.in</strong>
                      </span>
                    </div>
                  </div>
                </div>
                <div className='col-md-6'>
                  <div
                    className='form-wrapper'
                    data-aos='fade-up'
                    data-aos-delay={300}
                  >
                    <form id='contactForm' onSubmit={handleSubmit}>
                      <div className='row   mb-3'>
                        <div className='col-md-6'>
                          <label className='mb-2' htmlFor='name'>
                            Name
                          </label>
                          <input
                            className='form-control'
                            id='name'
                            type='text'
                            name='name'
                            maxlength='30'
                            value={formData.name}
                            required
                            onChange={handleChange}
                          />
                        </div>
                        <div className='col-md-6'>
                          <label className='mb-2' htmlFor='email'>
                            Email
                          </label>
                          <input
                            className='form-control'
                            id='email'
                            type='email'
                            maxlength='30'
                            name='email'
                            value={formData.email}
                            required
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className='row gap-3 mb-3'>
                        <div className='col-md-12'>
                          <label className='mb-2' htmlFor='subject'>
                            Subject
                          </label>
                          <input
                            className='form-control'
                            id='subject'
                            maxlength='500'
                            type='text'
                            name='subject'
                            value={formData.subject}
                            required
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div className='row gap-3 gap-md-0 mb-3'>
                        <div className='col-md-12'>
                          <label className='mb-2' htmlFor='message'>
                            Message
                          </label>
                          <textarea
                            className='form-control'
                            id='message'
                            name='message'
                            rows={5}
                            maxlength='500'
                            value={formData.message}
                            required
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <button
                        className='btn btn-primary text-sm px-4 py-2 white-color fw-semibold'
                        type='submit'
                      >
                        Send Message
                      </button>
                    </form>
                    {showSuccess && (
                      <div
                        className='mt-3 alert alert-success'
                        id='successMessage'
                      >
                        Message sent successfully!
                      </div>
                    )}
                    {showError && (
                      <div
                        className='mt-3 alert alert-danger'
                        id='errorMessage'
                      >
                        Message sending failed. Please try again later.
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section> */}
          {/* End Contact*/}
          {/* ======= Footer =======*/}
          {/* <footer className='footer pt-5 pb-5'>
            <div className='container'>
              <div className='row   mb-5 g-xl-5'>
                <div className='col-md-4 mb-5 mb-lg-0'>
                  <h3 className='mb-3'>Address</h3>
                  <p className='d-flex mb-3'>
                    <i className='bi bi-geo-alt-fill me-3' />
                    <span>
                      <a
                        href='https://maps.app.goo.gl/2fZ4FMLxs77sq8SW7'
                        target='_blank'
                        rel='noreferrer'
                      >
                        MAPA Centre, <br />
                        Coimbatore - 641037,
                        <br /> Tamilnadu, India.
                      </a>
                    </span>
                  </p>
                </div>
                <div className='col-md-4'>
                  <div className='row g-2'>
                    <div className='col-md-12 col-lg-12 mb-12 mb-lg-0'>
                      <h3 className='mb-3'>Get in touch</h3>
                      <div>
                        <div className='d-flex mb-2'>
                          <i className='bi bi-envelope-fill me-3' />
                          <p className='flex mb-0'>
                            anand@i-design.in
                            {/* <br />
                            kari@i-design.in */}
          {/* </p>
                        </div>
                        <div className='d-flex mb-2'>
                          <i className='bi bi-telephone-fill me-3' />
                          <p className='mb-0'>
                            +91-422-4541284
                            {/* <br /> Chennai Office : +91-44-43356127  
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-md-4 mb-5 mb-lg-0'>
                  <div className='section-title section-title-sm position-relative pb-3 '>
                    <h3 className='mb-0'>Quick Links</h3>
                  </div>
                  <div className='link-animated d-flex flex-column '>
                    <a className='mb-2' href='#home'>
                      <i className='bi bi-arrow-right text-primary me-2' />
                      Home
                    </a>
                    <a className='mb-2' href='#about'>
                      <i className='bi bi-arrow-right text-primary me-2' />
                      About Us
                    </a>
                    <a className='mb-2' href='#services'>
                      <i className='bi bi-arrow-right text-primary me-2' />
                      Services
                    </a>
                    <a className='mb-2' href='#products'>
                      <i className='bi bi-arrow-right text-primary me-2' />
                      Products
                    </a>

                    <a className='' href='#contact'>
                      <i className='bi bi-arrow-right text-primary me-2' />
                      Contact
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </footer> */}

          <section
            id='buildcontact'
            className='py-20 sm:py-32 bg-primary text-primary-foreground'
            style={{ color: '#fcfcfc !important' }}
          >
            <div className='container mx-auto px-4 sm:px-6 lg:px-8'>
              <div className='text-center space-y-8 max-w-3xl mx-auto'>
                <h2
                  className='text-3xl sm:text-4xl lg:text-5xl font-bold white-color'
                  style={{ color: '#fcfcfc !important' }}
                >
                  Ready to Build Something Amazing?
                </h2>
                <p
                  className='text-lg text-primary-foreground/90 white-color'
                  style={{ color: '#fcfcfc !important' }}
                >
                  Let's discuss your project and explore how we can help bring
                  your vision to life.
                </p>
                <div className='flex flex-col sm:flex-row gap-4 justify-center'>
                  <button
                    // href='mailto:contact@i-design.in'
                    //href="#contact"
                    className='btn btn-secondary text-base'
                    onClick={() => setShowModal(true)}
                  >
                    Get in Touch
                    <svg
                      className='ml-2 h-4 w-4'
                      fill='none'
                      stroke='currentColor'
                      viewBox='0 0 24 24'
                    >
                      <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth='2'
                        d='M14 5l7 7m0 0l-7 7m7-7H3'
                      />
                    </svg>
                  </button>
                  <a
                    href='#products'
                    className='btn text-base bg-transparent border border-primary-foreground text-primary-foreground hover:bg-primary-foreground/10'
                  >
                    View Case Studies
                  </a>
                </div>
              </div>
            </div>
          </section>

          <footer className='border-t border-border py-12 bg-muted/30'>
            <div className='container mx-auto px-4 sm:px-6 lg:px-8'>
              <div className='grid md:grid-cols-4 gap-8'>
                <div className='space-y-4'>
                  <div className='flex items-center gap-2'>
                    {/* <div className='flex h-8 w-8 items-center justify-center rounded-lg bg-primary'>
                      <span className='text-lg font-bold text-primary-foreground'>
                        iD
                      </span>
                    </div>
                    <span className='text-lg font-semibold'>iDesign</span> */}
                    {/* <img
                      className='logo dark img-fluid'
                      src={`${imagepath}assets/images/logolight.png`}
                      alt='idesign dark'
                    /> */}
                    {/* logo light*/}
                    {/* <img
                      className='logo light img-fluid'
                      src='/assets/images/logo.png'
                      alt='idesign light'
                    /> */}
                    <a href='#home'>
                      <img
                        className='logo light img-fluid'
                        src={`${imagepath}assets/images/idesign.jpg`}
                        alt='idesign light'
                        style={{ height: '40px' }}
                      />
                    </a>
                    {/* <a
                      className='navbar-brand brand'
                      href='#home'
                      aria-label='iDesign Technologies Pvt Ltd'
                    >
                      <span className='brand-text '>
                        <span className='brand-line1'>
                          <span className='logo-design'>iDESIGN</span>
                        </span> */}
                    {/* <span className='brand-line2'>
                          Technologies Pvt Ltd
                        </span> */}
                    {/* </span>
                    </a> */}
                  </div>
                  <p className='text-sm text-muted-foreground'>
                    Building innovative digital experiences for businesses
                    worldwide.
                  </p>
                </div>
                <div>
                  <h4 className='font-semibold mb-4'>Services</h4>
                  <ul className='space-y-2 text-sm text-muted-foreground'>
                    <li>
                      <a
                        href='#services'
                        className='hover:text-foreground transition-colors'
                      >
                        Web Development
                      </a>
                    </li>
                    <li>
                      <a
                        href='#services'
                        className='hover:text-foreground transition-colors'
                      >
                        Mobile Apps
                      </a>
                    </li>
                    <li>
                      <a
                        href='#services'
                        className='hover:text-foreground transition-colors'
                      >
                        Custom Software
                      </a>
                    </li>
                    <li>
                      <a
                        href='#services'
                        className='hover:text-foreground transition-colors'
                      >
                        UI/UX Design
                      </a>
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className='font-semibold mb-4'>Company</h4>
                  <ul className='space-y-2 text-sm text-muted-foreground'>
                    <li>
                      <a
                        href='#about'
                        className='hover:text-foreground transition-colors'
                      >
                        About Us
                      </a>
                    </li>
                    <li>
                      <a
                        href='#products'
                        className='hover:text-foreground transition-colors'
                      >
                        Products
                      </a>
                    </li>
                    <li>
                      <a
                        href='#how-it-works'
                        className='hover:text-foreground transition-colors'
                      >
                        How it works
                      </a>
                    </li>
                    <li>
                      <a
                        href='#contact'
                        onClick={() => setShowModal(true)}
                        className='hover:text-foreground transition-colors'
                      >
                        Contact
                      </a>
                    </li>
                  </ul>
                </div>
                <div>
                  <h4 className='font-semibold mb-4'>Connect</h4>
                  <ul className='space-y-2 text-sm text-muted-foreground'>
                    <li>
                      <a
                        href='https://linkedin.com'
                        target='_blank'
                        rel='noreferrer'
                        className='hover:text-foreground transition-colors'
                      >
                        LinkedIn
                      </a>
                    </li>
                    <li>
                      <a
                        href='https://twitter.com'
                        target='_blank'
                        rel='noreferrer'
                        className='hover:text-foreground transition-colors'
                      >
                        Twitter
                      </a>
                    </li>
                    <li>
                      <a
                        href='https://github.com'
                        target='_blank'
                        rel='noreferrer'
                        className='hover:text-foreground transition-colors'
                      >
                        GitHub
                      </a>
                    </li>
                    <li>
                      <a
                        href='mailto:contact@i-design.in'
                        target='_blank'
                        rel='noreferrer'
                        className='hover:text-foreground transition-colors'
                      >
                        Email
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className='mt-12 pt-8 border-t border-border text-center text-sm text-muted-foreground'>
                <p>
                  &copy; 2026 <span id='currentYear'></span> iDesign
                  Technologies. All rights reserved.
                </p>
              </div>
            </div>
          </footer>
          {/* End Footer*/}
        </main>
      </div>

      {/* ======= Back to Top =======*/}
      <button id='back-to-top'>
        <i className='bi bi-arrow-up-short' />
      </button>
      <ContactFormNew show={showModal} onClose={() => setShowModal(false)} />
    </>
  )
}

export default Home
